module.exports = __webpack_public_path__ + "static/img/img-background-2.ba7fd54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-2.jpg
// module id = 1T3m
// module chunks = 36